<!-- QR QUE ET PORTA A LA VISUALITZACIÓ DEL DOCUMENT DIGITAL -->
<div *ngIf="routePartCMR">
    <div *ngIf="formatDocumentQRCode" class="codeqr" (click)="onClickQR()">
        <div *ngIf="showcount" class="countinfo">{{ count }}</div>
        <div class="block-qr">
            <div class="img"><img [src]="formatDocumentQRCode" /></div>
            <div class="help-qr">{{ helpResource | translate }}</div>
            <div class="title">{{routePartCMR.routePartCMRKey}}</div>
        </div>
    </div>
</div>
